module.exports = __webpack_public_path__ + "8af69211.svg";